import { render, staticRenderFns } from "./GerarResultadoDocumental.vue?vue&type=template&id=46d6883a"
import script from "./GerarResultadoDocumental.vue?vue&type=script&lang=js"
export * from "./GerarResultadoDocumental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports